import React, { useMemo } from "react";
import { UserRoleFriendlyNames } from "../../../Enums/UserRoleEnum";
import { ViewIcon } from "../../../utils/ViewIcons";

const Badge = ({ children, className = "" }) => <span className={`va-badge ${className}`}>{children}</span>;

const ViewsMode = ({ views, search }) => {
  const q = (search || "").trim().toLowerCase();

  const grouped = useMemo(() => {
    const filtered = views.filter((v) => {
      if (!q) return true;
      const rolesText = (v.roles || [])
        .map((r) => UserRoleFriendlyNames[r.role] || String(r.role))
        .join(" ");

      const usersText = (v.users || [])
        .map((u) => `${u.preferredName} ${u.email || ""}`)
        .join(" ");

      const hay = `${v.name} ${v.description} ${v.viewGroup} ${rolesText} ${usersText}`.toLowerCase();
            return hay.includes(q);
          });

    const map = new Map();
    for (const v of filtered) {
      const key = v.viewGroup && v.viewGroup.trim() ? v.viewGroup : "(Brak grupy)";
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(v);
    }

    return Array.from(map.entries())
      .sort((a, b) => a[0].localeCompare(b[0], "pl"))
      .map(([groupName, list]) => ({
        groupName,
        list: list.sort((a, b) => (a.name || "").localeCompare(b.name || "", "pl")),
      }));
  }, [views, q]);

  return (
    <div className="va-content">
      {grouped.map((g) => (
        <div key={g.groupName} className="va-group">
          <div className="va-group-title">{g.groupName}</div>

          <div className="va-cards">
            {g.list.map((v) => (
              <div key={v.viewGuid} className="va-card">
                <div className="va-card-header">
                <div className="va-card-title">
                  <ViewIcon name={v.faIcon} className="va-icon" />
                  <span>{v.name}</span>
                </div>

                  <Badge className={v.isPublic ? "va-badge-public" : "va-badge-restricted"}>
                    {v.isPublic ? "Publiczny" : "Ograniczony"}
                  </Badge>
                </div>
                <div className="va-grid">
                  <div>
                    <div className="va-section-title">Role</div>
                    <div className="va-badges">
                      {(v.roles || []).length ? (
                        v.roles.map((r) => (
                          <Badge key={r.role} className="va-badge-role">
                            {UserRoleFriendlyNames[r.role] || `Rola ${r.role}`}
                          </Badge>
                        ))
                      ) : (
                        <span className="va-muted">- - - - -</span>
                      )}
                    </div>
                  </div>

                  <div>
                    <div className="va-section-title">Użytkownicy</div>
                    <div className="va-badges">
                      {(v.users || []).length ? (
                        v.users.map((u) => (
                          <Badge key={u.userGuid} className="va-badge-user">
                            {u.preferredName}
                          </Badge>
                        ))
                      ) : (
                        <>- - - - -</>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ViewsMode;
